import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Card,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Button,
} from 'reactstrap';
import { toast } from 'react-toastify';
import t, { partial } from '../../util/translation/translation';
import Loading from '../../shared/components/custom/Loading';
import Api from '../../util/api';
import useModal from '../../shared/hooks/useModal';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import { Link } from 'react-router-dom';
const MessageTemplatesPage = ({ initializeTemplate, useButton }) => {
  const s = partial('shared');
  const p = partial('MessagesPage');
  const [loading, setLoading] = useState(false);
  const [messageTemplates, setMessageTemplates] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const getMessageTemplates = async () => {
    setLoading(true);
    try {
      const messageTemplates =
        await Api.scheduleMessages.messageTemplates.getMessageTemplates();
      setMessageTemplates(messageTemplates);
      setLoading(false);
    } catch (err) {
      toast.error(err || 'error');
      setLoading(false);
    }
  };
  const deleteMessageTemplate = async () => {
    setLoading(true);
    try {
      await Api.scheduleMessages.messageTemplates.deleteMessageTemplate(
        deleteID
      );
      toast.success(t('shared.deleteSuccessful'));
    } catch (err) {
      toast.error(err);
    } finally {
      handleModal();
      getMessageTemplates();
    }
  };

  useEffect(() => {
    getMessageTemplates();
  }, []);

  const renderMessageTemplates = () => {
    return messageTemplates.map((template, i) => {
      return (
        <tr
          style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
          key={`renderMessageTemplates-${template.id}`}
        >
          <td>
            {/* Only SMS templates are saved without a title */}
            {template.title || <span className="text-muted">SMS</span>}
          </td>
          <td>{template.text}</td>
          <td>{template.url || '-- --'}</td>
          <td>
            {useButton ? (
              <Button
                size="sm"
                color="primary"
                style={{ marginBottom: 0 }}
                onClick={() => initializeTemplate(template)}
              >
                {p('use')}
              </Button>
            ) : (
              <UncontrolledDropdown className="dashboard__table-more">
                <DropdownToggle>
                  <DotsHorizontalIcon />
                </DropdownToggle>
                <DropdownMenu className="dropdown__menu">
                  <Link
                    onClick={() => initializeTemplate(template)}
                    to={`/messages?tab=1`}
                  >
                    <DropdownItem>{p('useTemplate')}</DropdownItem>
                  </Link>
                  <Link to={`/messages/message-templates/edit/${template.id}`}>
                    <DropdownItem>{s('edit')}</DropdownItem>
                  </Link>
                  <DropdownItem
                    onClick={() => handleModal(template.id)}
                    className="danger"
                  >
                    {s('deleteCaps')}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </td>
        </tr>
      );
    });
  };
  return (
    <Container>
      <Card>
        <DeleteModal
          visible={visible}
          type={p('messageTemplates')}
          handleModal={handleModal}
          modalAction={deleteMessageTemplate}
        />
        <Loading loading={loading} />
        <strong className="mb-0">{p('messageTemplates')}</strong>
        <div
          style={{
            display: 'flex',
            paddingBottom: 5,
            marginTop: 5,
            background: '#fff',
            borderRadius: 6,
            border: '1px solid rgba(0,0,0,0.08)',
          }}
        >
          <Table responsive striped>
            <thead>
              <tr>
                <th>{s('title')}</th>
                <th>{s('message')}</th>
                <th>{t('seasonObjectsShared.externalURL')}</th>
                <th />
              </tr>
            </thead>
            <tbody>{renderMessageTemplates()}</tbody>
          </Table>
        </div>
      </Card>
    </Container>
  );
};

export default MessageTemplatesPage;
